
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/en.js"
  import data from "/opt/build/repo/.cache/json/layout-en.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/en.js